import React, { useState, useEffect, useRef } from 'react';
import './Testimonial.css';

const Testimonials = () => {
  const trackRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [autoScrollPaused, setAutoScrollPaused] = useState(false);
  const timeoutRef = useRef(null);

  const testimonials = [
    {
      avatar: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/t6.jpg',
      name: 'Likith R K',
      text: 'The coaches are incredibly knowledgeable and always provide personalized attention. They truly care about your progress and make learning enjoyable.',
    },
    {
      avatar: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/t2.jpg',
      name: 'Ashutosh Routray',
      text: 'The courts are top-notch, and the whole facility is clean, modern, and well-equipped. Whether you\'re a beginner or experienced player, the environment here is perfect for enjoying a great game.',
    },
    {
      avatar: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/t3.jpg',
      name: 'Smayan Duvvuri',
      text: 'The coaches here are truly exceptional! They not only have deep technical knowledge but also know how to break down complex techniques into easy-to-understand steps.',
    },
    {
      avatar: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/t4.jpg',
      name: 'DEVANG SANYAL',
      text: 'I was often given constructive feedback on my game and while practicing. This continuously develops and accelerates my learning.',
    },
    {
      avatar: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/t5.jpg',
      name: 'Aparna',
      text: 'The coaches not only explain each shot clearly but also manage the games efficiently, ensuring everyone gets a fair rotation and stays engaged throughout the practice.',
    },
  ];
  

  useEffect(() => {
    if (autoScrollPaused) return;

    const interval = setInterval(() => {
      const nextIndex = (activeIndex + 1) % testimonials.length;
      scrollToIndex(nextIndex);
    }, 3000);

    return () => clearInterval(interval);
  }, [activeIndex, autoScrollPaused]);

  const handleScroll = () => {
    if (!trackRef.current) return;
    const index = Math.round(trackRef.current.scrollLeft / trackRef.current.offsetWidth);
    setActiveIndex(index);
    pauseAutoScroll();
  };

  const pauseAutoScroll = () => {
    setAutoScrollPaused(true);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setAutoScrollPaused(false);
    }, 5000);
  };

  const scrollToIndex = (index) => {
    if (!trackRef.current) return;
    trackRef.current.scrollTo({
      left: index * trackRef.current.offsetWidth,
      behavior: 'smooth'
    });
  };

  const handleTouchStart = (e) => {
    pauseAutoScroll();
    const touch = e.nativeEvent.touches[0];
    if (e.cancelable) e.preventDefault();
  };

  const scrollLeft = () => {
    const prevIndex = (activeIndex - 1 + testimonials.length) % testimonials.length;
    scrollToIndex(prevIndex);
  };

  const scrollRight = () => {
    const nextIndex = (activeIndex + 1) % testimonials.length;
    scrollToIndex(nextIndex);
  };

  return (
    <section className="testimonial-container">
      <h2 className="explore-title">Testimonial</h2>
      
      <div className="testimonial-wrapper">
        <button className="scroll-button left" onClick={scrollLeft}>&lt;</button>
        <div 
          className="testimonial-track"
          ref={trackRef}
          onScroll={handleScroll}
          onTouchStart={handleTouchStart}
          onTouchMove={pauseAutoScroll}
        >
          {testimonials.map((testimonial, index) => (
            <article 
              key={index}
              className={`testimonial-card ${index === activeIndex ? 'active' : ''}`}
            >
              <div className="avatar-container">
                <img 
                  src={testimonial.avatar} 
                  alt={testimonial.name}
                  className="client-avatar"
                />
              </div>
              <h3 className="client-name">{testimonial.name}</h3>
              <p className="testimonial-text">{testimonial.text}</p>
            </article>
          ))}
        </div>
        <button className="scroll-button right" onClick={scrollRight}>&gt;</button>
      </div>

      <div className="navigation-dots">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === activeIndex ? 'active' : ''}`}
            onClick={() => {
              scrollToIndex(index);
              pauseAutoScroll();
            }}
            aria-label={`View testimonial ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Testimonials;